<!--Copy right - © 2024 tecera gmbh-->
<script>
    import {
        is_authenticated,
        check_if_authenticated,
        rerout_user,
        user_role,
        user_name,
    } from "../scripts/auth.js";
    import { onMount, onDestroy } from "svelte";
    import {
        all_compound_water_meters,
        selected_device,
        dashboard_data,
    } from "../stores.js";
    import NavBar from "../components/NavBar.svelte";
    import Footer from "../components/Footer.svelte";
    import DeviceCard from "../components/dashboard/DeviceCard.svelte";
    import DeviceCardSmall from "../components/dashboard/DeviceCardSmall.svelte";
    import {
        get_compound_water_meters,
        get_dashboard,
    } from "../scripts/data.js";

    let headline = "Dashboard";
    let is_mounted = false;

    let data_promise;
    let show_loaders = false;

    onMount(async () => {
        is_mounted = true;
        $selected_device = null; // need to set this to null incase user comes from different tab
        await check_if_authenticated(); // waiting for auth before proceeding
        if (
            !$user_role["view_dashboard"] ||
            $user_role["view_dashboard"] != 1
        ) {
            rerout_user();
            return;
        }
        data_promise = new Promise((resolve) => {
            setTimeout(() => {
                resolve("Fake data for loader");
            }, 500);
        });

        fetch_water_meter_configs();

        // TODO: create live reloading here TODO: fetch Data here
        // if (ENABLE_LIVE_RELOADING) {
        //     alarm_fetch_interval = setInterval(
        //         get_alarms,
        //         ALARM_REFRESH_INTERVALL_IN_SECONDS * 1000,
        //     );
        //     data_fetch_interval = setInterval(
        //         refresh_water_meter_data,
        //         DATA_REFRESH_INTERVALL_IN_SECONDS * 1000,
        //     );
        // }
    });

    // TODO: implement data load function
    async function fetch_water_meter_configs() {
        show_loaders = true;
        await get_compound_water_meters();
        await get_dashboard();
        show_loaders = false;
    }

    // TODO: refresh
    // async function refresh_water_meter_data() {
    //     if (
    //         moment().diff(end_date) / 1000 <
    //         DATA_REFRESH_INTERVALL_IN_SECONDS * 4
    //     ) {
    //         end_date = moment();
    //     }
    //     if (
    //         $selected_device &&
    //         !$selected_device.box_id &&
    //         $all_compound_water_meters.some(
    //             (meter) => meter.id === $selected_device.id,
    //         )
    //     ) {
    //         get_compound_water_meter_data(
    //             $selected_device.id,
    //             start_date,
    //             end_date,
    //         );
    //     }
    // }

    onDestroy(() => {
        $all_compound_water_meters = [];
        // clearInterval(alarm_fetch_interval);
        // clearInterval(data_fetch_interval);
    });

    let amount_devices_green = 0,
        amount_devices_orange = 0,
        amount_devices_red = 0;
    let max_temp_green_devices = null;
    let max_temp_orange_devices = null;
    let sum_volume_flow_below_5 = 0;
    let red_device_min_temp = null;
    let amount_increased_water_usage = 0;

    // statics part variables
    let day_most_usage, day_most_usage_formatted;
    let device_id_most_usage, device_most_usage;
    let sum_all_devices_usage;

    $: if ($dashboard_data) {

        max_temp_green_devices = null;
        max_temp_orange_devices = null;
        sum_volume_flow_below_5 = 0;
        red_device_min_temp = null;
        amount_increased_water_usage = 0;

        // dashboard statistics part
        day_most_usage = $dashboard_data.statistics.most_usage_day;
        device_id_most_usage = $dashboard_data.statistics.most_used_device_id;
        sum_all_devices_usage = $dashboard_data.statistics.usage_all_devices;

        day_most_usage_formatted = new Intl.DateTimeFormat("de-DE", {
            day: "2-digit",
            month: "long",
        }).format(new Date(day_most_usage));

        device_most_usage =
            $dashboard_data.data.find(
                (device) => device[0].config_id == device_id_most_usage,
            ) || null;

        amount_devices_green = 0;
        amount_devices_orange = 0;
        amount_devices_red = 0;
        for (let device of $dashboard_data.data) {
            if (device[0].colour_coding === "green") {
                amount_devices_green += 1;
                if (device[0].statistics.temp_30_days_max !== null) {
                    max_temp_green_devices = Math.max(
                        max_temp_green_devices,
                        device[0].statistics.temp_30_days_max,
                    );
                }
            } else if (device[0].colour_coding === "orange") {
                amount_devices_orange += 1;
                if (device[0].statistics.temp_30_days_max !== null) {
                    max_temp_orange_devices = Math.max(
                        max_temp_orange_devices,
                        device[0].statistics.temp_30_days_max,
                    );
                }
            } else if (device[0].colour_coding === "red") {
                amount_devices_red += 1;
                if (device[0].statistics.temp_30_days_min !== null) {
                    red_device_min_temp = Math.min(
                        red_device_min_temp,
                        device[0].statistics.temp_30_days_min,
                    );
                }
                if (device[0].statistics.usage_30_days_above_50_count > 0) {
                    amount_increased_water_usage += 1;
                }
            }
            if (device[0].statistics.usage_1_day_below_5_count) {
                sum_volume_flow_below_5 +=
                    device[0].statistics.usage_1_day_below_5_count;
            }
        }
    }
</script>

<svelte:head>
    <title>myBach | Dashboard</title>
</svelte:head>

{#if $is_authenticated && $user_role["view_dashboard"] == 1}
    <div class="container-fluid">
        <div class="row">
            <!-- Main Content -->
            <main
                class="col-12 ml-sm-auto px-md-4 content_main dashboard-main"
                style="overflow:auto;"
            >
                <NavBar {headline} />
                <div class="row">
                    <div class="mt-4 ml-4 dashboard-user-name">
                        <p>{$user_name}</p>
                    </div>
                </div>
                <div class="row">
                    <!-- Name Display left side -->
                    <div class="col-1"></div>
                    <!-- Dashboard elements -->
                    <div class="col-9 dashboard-content">
                        <!-- Overview -->
                        <div class="row">
                            <div class="col-2"></div>
                            <div class="col-10">
                                <div class="row dashboard-overview">
                                    {#if $dashboard_data}
                                        {#each $dashboard_data.data as meter (meter[0].config_id)}
                                            <DeviceCard device={meter} />
                                        {/each}
                                    {/if}
                                </div>
                            </div>
                        </div>
                        <!-- Hygiene -->
                        <div class="row">
                            <div class="col-2">
                                <div class="dashboard-section-title">
                                    <p>Hygiene</p>
                                </div>
                            </div>
                            <div class="col-10">
                                <div class="row">
                                    <div class="card" style="width: 100%;">
                                        <div class="card-body">
                                            <h5
                                                class="card-title mb-4"
                                                style="display:flex;justify-content:space-between;"
                                            >
                                                <span>
                                                    <span style="color:green;">
                                                        {#if amount_devices_green === 1}
                                                            1 Gerät
                                                        {:else}
                                                            {amount_devices_green}
                                                            Geräte
                                                        {/if}
                                                    </span>
                                                    mit geringem, mikrobiellen Risiko.
                                                </span>
                                                <img
                                                    src="/img/water_drop.svg"
                                                    style="height:3rem;"
                                                />
                                            </h5>
                                            <p class="card-text">
                                                {#if max_temp_green_devices === null}
                                                    • Keine Temperaturdaten
                                                    vorhanden.
                                                {:else}
                                                    • Wassertemperatur konstant
                                                    unter {max_temp_green_devices}°C
                                                {/if}
                                                <br />• Regelmäßige
                                                Hygiene-Spülung ist in Takt.
                                            </p>
                                            <hr />
                                            <h5 class="card-title mb-4">
                                                <span style="color:orange;">
                                                    {#if amount_devices_orange === 1}
                                                        1 Gerät
                                                    {:else}
                                                        {amount_devices_orange} Geräte
                                                    {/if}
                                                </span>mit erhöhtem,
                                                mikrobiellen Risiko.
                                            </h5>
                                            <p class="card-text">
                                                {#if amount_devices_orange > 0 && max_temp_orange_devices >= 25}
                                                    • Wassertemperatur teilweise
                                                    bis zu {max_temp_orange_devices}°C
                                                    <br />
                                                {/if}
                                                {#if sum_volume_flow_below_5 >= 2}
                                                    • Unregelmäßige
                                                    Hygiene-Spülung: {sum_volume_flow_below_5}
                                                    Ausfälle in den letzten 24h
                                                {/if}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Funktion -->
                        <div class="row">
                            <div class="col-2">
                                <div class="dashboard-section-title">
                                    <p>Funktion</p>
                                </div>
                            </div>
                            <div class="col-10">
                                <div class="row">
                                    <div class="card" style="width: 100%;">
                                        <div class="card-body">
                                            <h5
                                                class="card-title mb-4"
                                                style="display:flex;justify-content:space-between;"
                                            >
                                                <span>
                                                    <span style="color:red;">
                                                        {#if amount_devices_red === 1}
                                                            1 Gerät
                                                        {:else}
                                                            {amount_devices_red}
                                                            Geräte
                                                        {/if}
                                                    </span>mit möglichen
                                                    Auffälligkeiten
                                                </span>
                                                <img
                                                    src="/img/wrench.svg"
                                                    style="height:3rem;"
                                                />
                                            </h5>
                                            <p class="card-text">
                                                {#if red_device_min_temp && red_device_min_temp < 3}
                                                    • Wassertemperatur teilweise
                                                    unter {red_device_min_temp}°C
                                                    <br />
                                                {/if}
                                                {#if amount_increased_water_usage > 0}
                                                    • Stark erhöhter
                                                    Wasserverbrauch
                                                {/if}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Nutzung -->
                        <div class="row">
                            <div class="col-2">
                                <div class="dashboard-section-title">
                                    <p>Nutzung</p>
                                </div>
                            </div>
                            <div class="col-10">
                                <div class="row dashboard-usage">
                                    <div class="card">
                                        <div class="card-body">
                                            <h5
                                                class="card-title mb-4"
                                                style="font-size: 36px; font-weight: bold;"
                                            >
                                                {#if day_most_usage}
                                                    {day_most_usage_formatted}
                                                {/if}
                                            </h5>
                                            <p class="card-text">
                                                <span
                                                    style="font-weight: 600;font-size:larger"
                                                    >Hier wurde am meisten
                                                    getrunken.</span
                                                ><br />
                                                In den letzten 90 Tagen.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-body">
                                            {#if device_most_usage}
                                                <div class="card-title mb-4">
                                                    <DeviceCardSmall
                                                        device={device_most_usage[0]}
                                                    />
                                                </div>
                                                <p class="card-text mt-2">
                                                    <span
                                                        style="font-weight: 600;font-size:larger"
                                                        >Ist der beliebteste
                                                        BACH.</span
                                                    ><br />
                                                    In den letzten 90 Tagen
                                                </p>
                                            {:else}
                                                <p class="card-text mt-2">
                                                    Kein BACH ohne
                                                    Auffälligkeiten und Daten
                                                    gefunden.
                                                </p>
                                            {/if}
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-body">
                                            <h5
                                                class="card-title mb-4 card-title-large"
                                                style="font-size: 36px; font-weight: bold;"
                                            >
                                                {#if $dashboard_data && $dashboard_data.statistics.usage_all_devices}
                                                    {(
                                                        $dashboard_data
                                                            .statistics
                                                            .usage_all_devices *
                                                        2000
                                                    ).toLocaleString("de-DE", {
                                                        maximumFractionDigits: 0,
                                                    })}
                                                {:else}
                                                    0
                                                {/if}
                                            </h5>
                                            <p class="card-text">
                                                <span
                                                    style="font-weight: 600;font-size:larger"
                                                    >PET-Flaschen gespart.</span
                                                ><br />
                                                In den letzten 30 Tagen.<br
                                                />5dl Flaschen.
                                            </p>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-body">
                                            <h5
                                                class="card-title mb-4"
                                                style="font-size: 36px; font-weight: bold;display:flex;justify-content:space-between;"
                                            >
                                                {#if $dashboard_data && $dashboard_data.statistics.usage_all_devices}
                                                    {(
                                                        $dashboard_data
                                                            .statistics
                                                            .usage_all_devices *
                                                        2000 *
                                                        9.8958
                                                    ).toLocaleString("de-DE", {
                                                        minimumFractionDigits: 0,
                                                        maximumFractionDigits: 2,
                                                    })} kg
                                                {:else}
                                                    0 kg
                                                {/if}
                                                <img
                                                    src="/img/leaf.svg"
                                                    style="height:3rem;"
                                                />
                                            </h5>
                                            <p class="card-text">
                                                <span
                                                    style="font-weight: 600;font-size:larger"
                                                    >CO2 Emissionen wurden
                                                    reduziert.</span
                                                ><br />
                                                In den letzten 30 Tagen.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- White space right side -->
                    <div class="col-1"></div>
                </div>
            </main>
        </div>
    </div>
    <Footer />
{/if}
